import test from "./test.png";
/* AppleBusinessChat */
import textBusinessChat from "./BusinessChat/text-business-chat.png";
import mediaBusinessChat from "./BusinessChat/media-link-business-chat.png";
import weblinkBusinessChat from "./BusinessChat/weblink-business-chat.png";
import paymentInvoiceBusinessChat from "./BusinessChat/payment-invoice-business-chat.png";
import stateChatBusinessChat from "./BusinessChat/state-chat-business-chat.png";
/* BlipChat  */
import audioBlipChat from "./BlipChat/audio-blip-chat.png";
import carouselBlipChat from "./BlipChat/carousel-blip-chat.png";
import chatStateBlipChat from "./BlipChat/chat-state-blip-chat.png";
import documentBlipChat from "./BlipChat/document-blip-chat.png";
import imageBlipChat from "./BlipChat/image-blip-chat.png";
import menuBlipChat from "./BlipChat/menu-blip-chat.png";
import quickReplyBlipChat from "./BlipChat/quick-reply-blip-chat.png";
import requestLocationBlipChat from "./BlipChat/request-location-blip-chat.png";
import sendLocationBlipChat from "./BlipChat/send-location-blip-chat.png";
import textBlipChat from "./BlipChat/text-blip-chat.png";
import videoBlipChat from "./BlipChat/video-blip-chat.png";
import weblinkBlipChat from "./BlipChat/weblink-blip-chat.png";
import gifBlipChat from "./BlipChat/gif-blip-chat.png";
/* Email */
import audioEmail from "./Email/audio-email.png";
import documentEmail from "./Email/document-email.png";
import gifEmail from "./Email/gif-email.png";
import imageEmail from "./Email/image-email.png";
import menuEmail from "./Email/menu-email.png";
import sendLocationEmail from "./Email/send-location-email.png";
import textEmail from "./Email/text-email.png";
import videoEmail from "./Email/video-email.png";
import weblinkEmail from "./Email/weblink-email.png";
/* Messenger */ 
import carouselMessenger from "./Messenger/carousel-messenger.png";
import chatStateMessenger from "./Messenger/chat-state-messenger.png";
import quickReplyMessenger from "./Messenger/quick-reply-messenger.png";
import textMessenger from "./Messenger/text-messenger.png";
import weblinkMessenger from "./Messenger/weblink-messenger.png";
import paymentReceiptMessenger from "./Messenger/payment-receipt-messenger.png";
import menuMessenger from "./Messenger/menu-messenger.png";
import audioMessenger from "./Messenger/audio-messenger.png";
import documentsMessenger from "./Messenger/documents-messenger.png";
import imageMessenger from "./Messenger/image-messenger.png";
import videoMessenger from "./Messenger/video-messenger.png";
import gifMessenger from "./Messenger/gif-messenger.png"
/* Google Assistant */
import audioGoogleAssistant from "./GoogleAssistant/audio-google-assistant.png";
import carosselGoogleAssistant from "./GoogleAssistant/carossel-google-assistant.png";
import imageGoogleAssistant from "./GoogleAssistant/image-google-assistant.png";
import listGoogleAssistant from "./GoogleAssistant/list-google-assistant.png";
import quickReplyGoogleAssistant from "./GoogleAssistant/quick-reply-google-assistant.png";
import textGoogleAssistant from "./GoogleAssistant/text-google-assistant.png";
import weblinkGoogleAssistant from "./GoogleAssistant/weblink-google-assistant.png";
import requestLocationGoogleAssistant from "./GoogleAssistant/requestLocation-google-assistant.png";
/* Google RCS */
import carrosselGoogleRcs from "./GoogleRCS/carrossel-google-rcs.png";
import mediaGoogleRcs from "./GoogleRCS/media-google-rcs.png";
import menuGoogleRcs from "./GoogleRCS/menu-google-rcs.png";
import quickReplyGoogleRcs from "./GoogleRCS/quick-reply-google-rcs.png";
import requestLocationGoogleRcs from "./GoogleRCS/request-location-google-rcs.png";
import textGoogleRcs from "./GoogleRCS/text-google-rcs.png";
/* Skype */
import textSkype from "./Skype/text-skype.png";
/* Telegram */
import audioTelegram from "./Telegram/audio-telegram.png";
import chatStateTelegram from "./Telegram/chat-state-telegram.png";
import documentsTelegram from "./Telegram/documents-telegram.png";
import imageTelegram from "./Telegram/image-telegram.png";
import menuTelegram from "./Telegram/menu-telegram.png";
import locationTelegram from "./Telegram/send-location-telegram.png";
import videoTelegram from "./Telegram/video-telegram.png";
import weblinkTelegram from "./Telegram/weblink-telegram.png";
import textTelegram from "./Telegram/text-telegram.png";
import quickReplyTelegram from "./Telegram/quick-reply-telegram.png";
/* Telegram */
import textInfobip from "./Infobip/infobip.png";
/* Whatsapp */
import audioWhatsapp from "./Whatsapp/audio.png";
import documentsWhatsapp from "./Whatsapp/documents.png";
import locationWhatsapp from "./Whatsapp/location.png";
import textWhatsapp from "./Whatsapp/text.png";
import videoWhatsapp from "./Whatsapp/video.png";
import imageWhatsapp from "./Whatsapp/imagem.png";
import weblinkWhatsapp from "./Whatsapp/weblink.png";
import quickWhatsApp from "./Whatsapp/quickReply.png";
/*Microsoft Teams*/
import audioMicrosoftTeams from "./MicrosoftTeams/audio.png";
import documentsMicrosoftTeams from "./MicrosoftTeams/document.png";
import carrouselMicrosoftTeams from "./MicrosoftTeams/carrousel.png";
import chatStateMicrosoftTeams from "./MicrosoftTeams/chat-state.png";
import menuMicrosoftTeams from "./MicrosoftTeams/menu.png";
import textMicrosoftTeams from "./MicrosoftTeams/text.png";
import videoMicrosoftTeams from "./MicrosoftTeams/video.png";
import imageMicrosoftTeams from "./MicrosoftTeams/image.png";
import weblinkMicrosoftTeams from "./MicrosoftTeams/weblink.png";
import quickReplyMicrosoftTeams from "./MicrosoftTeams/quickReply.png";


export const sampleImages = {
    test,
    textBusinessChat,
    mediaBusinessChat,
    weblinkBusinessChat,
    paymentInvoiceBusinessChat,
    stateChatBusinessChat,
    audioBlipChat,
    carouselBlipChat,
    chatStateBlipChat,
    documentBlipChat,
    imageBlipChat,
    menuBlipChat,
    quickReplyBlipChat,
    requestLocationBlipChat,
    sendLocationBlipChat,
    textBlipChat,
    videoBlipChat,
    weblinkBlipChat,
    gifBlipChat,
    audioEmail,
    documentEmail,
    gifEmail,
    imageEmail,
    menuEmail ,
    sendLocationEmail,
    textEmail ,
    videoEmail,
    weblinkEmail,
    carouselMessenger,
    chatStateMessenger,
    quickReplyMessenger,
    textMessenger,
    weblinkMessenger,
    paymentReceiptMessenger,
    menuMessenger,
    audioMessenger,
    documentsMessenger,
    imageMessenger,
    videoMessenger,
    gifMessenger,
    audioGoogleAssistant,
    carosselGoogleAssistant,
    imageGoogleAssistant,
    listGoogleAssistant,
    quickReplyGoogleAssistant,
    textGoogleAssistant,
    weblinkGoogleAssistant,
    requestLocationGoogleAssistant,
    carrosselGoogleRcs,
    mediaGoogleRcs,
    menuGoogleRcs,
    quickReplyGoogleRcs,
    requestLocationGoogleRcs,
    textGoogleRcs,
    textSkype,
    audioTelegram,
    chatStateTelegram,
    documentsTelegram,
    imageTelegram ,
    menuTelegram ,
    locationTelegram,
    videoTelegram,
    weblinkTelegram,
    textTelegram,
    quickReplyTelegram,
    textInfobip,
    audioWhatsapp,
    documentsWhatsapp,
    locationWhatsapp,
    textWhatsapp,
    videoWhatsapp,
    weblinkWhatsapp,
    imageWhatsapp,
    quickWhatsApp,
    audioMicrosoftTeams,
    documentsMicrosoftTeams,
    textMicrosoftTeams,
    videoMicrosoftTeams,
    imageMicrosoftTeams,
    weblinkMicrosoftTeams,
    carrouselMicrosoftTeams,
    chatStateMicrosoftTeams,
    menuMicrosoftTeams,
    quickReplyMicrosoftTeams

};